(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab"] && !Shopify.designMode) return;
  try {
    
  class TabsSwitcher extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }
    init() {
      const nav = this.querySelector('[data-nav]');
      this.items = [...this.querySelectorAll('[data-tab-item]')];
      this.btns = this.items.map((it) => it.querySelector('[data-tab-button]'));
      this.panels = this.items.map((it) => it.querySelector('[data-tab-panel]'));
      this.btns.forEach((b, i) => {
        nav.appendChild(b);
        b.addEventListener('click', () => this.show(i));
        b.addEventListener('keydown', (e) => {
          const n = this.btns.length;
          const k = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: n - 1 }[e.key];
          if (k === undefined) return;
          e.preventDefault();
          this.show((k + n) % n, true);
        });
      });
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.items.findIndex((it) => it === e.target || it.contains(e.target));
        if (i > -1) this.show(i);
      });
      this.dataset.ready = '';
      this.show(0);
    }
    show(i, focus) {
      this.btns.forEach((b, j) => {
        b.setAttribute('aria-selected', j === i);
        b.tabIndex = j === i ? 0 : -1;
      });
      this.panels.forEach((p, j) => (p.hidden = j !== i));
      if (focus) this.btns[i].focus();
    }
  }
  if (!customElements.get('tabs-switcher')) customElements.define('tabs-switcher', TabsSwitcher);

  } catch(e) { console.error(e); }
})();
})();
